import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { TooltipProvider } from "@shared/ui/tooltip";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { KPIMetrics } from "../dashboard/dashboard";
import { SystemsTable } from "../list/list";

const Systems = () => {
  const navigate = useNavigate();

  return (
    <TooltipProvider>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <PageHeader
              title="Systems"
              subtitle="Manage and monitor all operational systems within your utility"
            />
          </div>
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={() => navigate("/onboarding/data-migration/data-cards")}
            >
              <Plus className="h-4 w-4 mr-2" />
              Bulk Add
            </Button>
            <Button
              onClick={() => navigate("/ax/asset-registry/systems/create")}
            >
              <Plus className="w-4 h-4 mr-2" />
              Add New System
            </Button>
          </div>
        </div>

        {/* KPI Metrics */}
        <KPIMetrics />

        {/* Table */}
        <SystemsTable />
      </div>
    </TooltipProvider>
  );
};

export default Systems;
